import { Box, Stack, Typography, styled, type SxProps, type Theme } from "~/common/mui";
import { ControlInfo } from "./ControlInfo";
import type { HeroControlViewModel } from "./controlViewModel";

export interface HeroControlProps extends Omit<HeroControlViewModel, "type" | "controlIndex"> {
  className?: string;
  sx?: SxProps<Theme>;
}

const HeroImageFrame = styled(Box)(({ theme }) => ({
  width: "100%",
  aspectRatio: "52 / 15",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.surfaceContainer.low,
}));

const HeroImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "contain",
});

export const HeroControl = ({
  label,
  hideLabel = false,
  description,
  info,
  imageUrl,
  className,
  sx,
}: HeroControlProps) => (
  <Stack gap={1} className={className} sx={sx}>
    {!hideLabel ? (
      <Stack direction="row" gap={1} alignItems="center">
        <Typography variant="bodyLarge">{label}</Typography>
        {info ? <ControlInfo {...info} /> : null}
      </Stack>
    ) : null}
    {description ? (
      <Typography variant="bodySmall" color="textSecondary">
        {description}
      </Typography>
    ) : null}
    {imageUrl ? (
      <HeroImageFrame>
        <HeroImage src={imageUrl} alt="" />
      </HeroImageFrame>
    ) : null}
  </Stack>
);
